import { combineReducers } from 'redux';
import { CarPolicyClaimReducer } from './CarPolicyClaim';
import { PersonalAccidentPolicyClaimReducer } from './PersonalAccidentPolicyClaim';
import { CancerPolicyClaimReducer } from './CancerPolicyClaim';
import { CorporateHealthPolicyClaimReducer } from './CorporateHealthPolicyClaim';
import { HealthPolicyClaimReducer } from './HealthPolicyClaim';

export default combineReducers({
  carPolicyClaim: CarPolicyClaimReducer,
  personalAccidentPolicyClaim: PersonalAccidentPolicyClaimReducer,
  cancerPolicyClaim: CancerPolicyClaimReducer,
  corporateHealthPolicyClaim: CorporateHealthPolicyClaimReducer,
  healthPolicyClaim: HealthPolicyClaimReducer,
});
